(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-gyrol-production]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const video = section.querySelector('video');
      const frame = section.querySelector('.gyrol-production__frame');
      const playButton = section.querySelector('[data-production-play]');
      const type = section.dataset.videoType;
      const videoId = section.dataset.videoId;
      let started = false;

      if (!frame) return;

      const startPlayback = async () => {
        if (started) return;
        if (video) {
          video.muted = true;
          video.playsInline = true;
          try {
            await video.play();
            started = true;
            section.classList.add('is-playing');
          } catch (_error) {
            // Keep the poster and play control available if autoplay is blocked.
          }
          return;
        }

        if (!videoId || (type !== 'youtube' && type !== 'vimeo')) return;
        const iframe = document.createElement('iframe');
        const source = type === 'youtube'
          ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&mute=1&playsinline=1&controls=1&rel=0`
          : `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?autoplay=1&muted=1&playsinline=1&controls=1`;
        iframe.src = source;
        iframe.title = section.dataset.videoTitle || 'La produzione GYROL';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';
        frame.appendChild(iframe);
        started = true;
        section.classList.add('is-playing');
      };

      playButton?.addEventListener('click', startPlayback);

      if (videoId || video) {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!prefersReducedMotion && 'IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.unobserve(section);
              startPlayback();
            });
          }, { threshold: 0.35 });
          observer.observe(section);
        }
      }
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
